import {useQuery} from '@tanstack/react-query';
import axios from 'axios';

import {referenceDataQueryKeys} from './referenceDataQueryKeys';

const useHealthBoardAreas = () => {
  // `refetch` is exposed so a consumer can offer a Retry action next to the
  // announced failure instead of leaving the surface stuck.
  const {data, isLoading, isFetching, error, refetch} = useQuery({
    queryKey: referenceDataQueryKeys.healthBoardAreas(),
    queryFn: async () => await axios.get('/api/health-board-areas').then((res) => res.data),
    staleTime: Infinity,
  });

  return {data, isLoading, isFetching, error, refetch};
};

export default useHealthBoardAreas;
